import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { getRoundFromIdAtom } from "../getRoundFromIdAtom/getRoundFromIdAtom";

export const getCourseLayoutFromRoundIdAtom = atomFamily((roundId: string) => {
  return atom((get) => {
    const round = get(getRoundFromIdAtom(roundId));
    return round?.type === "Golf" ? round?.courseLayout : null;
  });
});
